// extracted by mini-css-extract-plugin
export var loadingSpinner = "_1a-0";
export var spinnerContainer = "_1a-1";